import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let sigilSwiperWr = document.querySelectorAll('.sigil-swiper-wr');
sigilSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    const cards = Array.from(el.querySelectorAll('[data-sigil-card]'));
    const activeClass = 'is-active';
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let measureFrame = null;
    let swiperUpdateTimer = null;
    let swiper;

    const getActiveCard = () => cards.find((card) => card.classList.contains(activeClass));

    const getCopyHeight = (card) => {
      const text = card ? card.querySelector('.sigil-sec__item-text') : null;

      return text ? Math.ceil(text.scrollHeight + 2) : 0;
    };

    const updateActiveCopyHeight = (activeCard = getActiveCard() || cards[0]) => {
      el.style.setProperty('--sigil-active-copy-height', `${getCopyHeight(activeCard)}px`);
    };

    const scheduleCopyHeightsUpdate = () => {
      if (measureFrame) cancelAnimationFrame(measureFrame);

      measureFrame = requestAnimationFrame(() => {
        measureFrame = null;
        updateActiveCopyHeight();
      });
    };

    const isClickLayout = () => window.innerWidth <= 1033 || !hoverQuery.matches;
    const isSlideControlledLayout = () => window.innerWidth <= 640;

    const scheduleSwiperUpdate = () => {
      if (swiperUpdateTimer) clearTimeout(swiperUpdateTimer);

      swiperUpdateTimer = setTimeout(() => {
        swiperUpdateTimer = null;

        if (swiper) {
          swiper.update();
        }
      }, reducedMotionQuery.matches ? 0 : 780);
    };

    const applyActiveCard = (activeCard) => {
      if (!activeCard) return;

      cards.forEach((card) => {
        const isActive = card === activeCard;

        card.classList.toggle(activeClass, isActive);
        card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    };

    const setActiveCard = (activeCard) => {
      if (!activeCard) return;

      updateActiveCopyHeight(activeCard);
      applyActiveCard(activeCard);
      scheduleSwiperUpdate();
    };

    const resetActiveCard = () => {
      if (window.innerWidth <= 640 && swiper) {
        setActiveSlideCard(swiper);
        return;
      }

      setActiveCard(cards[0]);
    };

    const setActiveSlideCard = (swiperInstance) => {
      if (window.innerWidth > 640) return;

      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];

      if (activeSlide && activeSlide.matches('[data-sigil-card]')) {
        setActiveCard(activeSlide);
      }
    };

    cards.forEach((card) => {
      card.setAttribute('aria-expanded', card.classList.contains(activeClass) ? 'true' : 'false');

      card.addEventListener('pointerenter', () => {
        if (!isClickLayout()) {
          setActiveCard(card);
        }
      });

      card.addEventListener('focusin', () => {
        if (isSlideControlledLayout()) return;

        setActiveCard(card);
      });

      card.addEventListener('click', () => {
        if (isSlideControlledLayout()) return;

        setActiveCard(card);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        if (isSlideControlledLayout()) return;

        setActiveCard(card);
      });
    });

    updateActiveCopyHeight(getActiveCard() || cards[0]);
    applyActiveCard(getActiveCard() || cards[0]);

    document.addEventListener('click', (event) => {
      if (el.contains(event.target)) return;

      resetActiveCard();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        resetActiveCard();
      }
    });

    swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 0,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        641: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1023: {
          slidesPerView: 5,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on:{
      afterInit: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
            scheduleCopyHeightsUpdate()
            setActiveSlideCard(this)
        },

        slideChange: function(){
            setActiveSlideCard(this)
        },

        resize: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
            scheduleCopyHeightsUpdate()
            setActiveSlideCard(this)
        }
      }
    });
    swiperObserver(swiper);
    updateActiveCopyHeight();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleCopyHeightsUpdate).catch(scheduleCopyHeightsUpdate);
    }

    window.addEventListener('load', scheduleCopyHeightsUpdate, { once: true });
  }
});
